import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SenderId, SenderIdItem, SenderIdItemWithOpaList, SenderIdPendingItem } from '../interfaces/sender-id.interface';
import { ToxicityListItem } from '../interfaces/toxicity-list-item.interface';
import { SenderIdSameAccountListItem } from '../interfaces/sender-id-same-account-list-item.interface';
import { SenderIdSimilarAccountListItem } from '../interfaces/sender-id-similar-account-list-item.interface';
import { map } from 'rxjs/operators'; // <-- Import the map operator
import { KeyDataPayload, transformKeyDataPayload } from '../utilities/payload/key-data-payload';
import { decode } from '@msgpack/msgpack';

const sharedUrl = '/senderidregistry/manage/senderid';

@Injectable({
  providedIn: 'root',
})
export class SenderIdService {
  private http = inject(HttpClient);

  getSenderIdPendingList$() {
    return this.http.get<SenderIdPendingItem[]>(`${sharedUrl}/pending-list`);
  }

  getSenderIdList$(rejected = false, withdrawn = false) {
    const apiUrl = `${sharedUrl}/list/${rejected}/${withdrawn}/condensed`;

    return this.http.get(apiUrl, { responseType: 'arraybuffer' }).pipe(
      map(buffer => {
        const decodedData = decode(buffer) as any[];

        return decodedData.map((item: any) => ({
          senderIdID: item[0],
          senderIDText: item[1],
          organisationName: item[2],
          statusDesc: item[3],
          isPending: item[4],
          approvedDate: item[5] ? new Date(item[5]) : undefined,
          registrationDate: item[6] ? new Date(item[6]) : undefined,
          pendingAuthorisations: item[7],
          opaNameList: item[8] || [],
          thirdPartyNameList: item[9] || []
        })) as SenderIdItemWithOpaList[];
      })
    );
  }

  getSenderIdToxicityList$(id: number) {
    return this.http.get<ToxicityListItem[]>(`${sharedUrl}/${id}/toxicity`);
  }

  getSenderIdSameAccountList$(id: number) {
    return this.http.get<SenderIdSameAccountListItem[]>(`${sharedUrl}/${id}/same-organisation`);
  }

  getSenderIdSimilarAccountList$(id: number) {
    return this.http.get<SenderIdSimilarAccountListItem[]>(`${sharedUrl}/${id}/similar`);
  }

  getSenderId$(id: number) {
    return this.http.get<SenderId>(`${sharedUrl}/${id}`);
  }
}
